import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchInterceptors } from "../../Api/fetchInterceptors";

const REACT_APP_END_POINT_SUBMIT_FEEDBACK_FORM =
  process.env.REACT_APP_END_POINT_SUBMIT_FEEDBACK_FORM;

export const submit_User_feedback_Api = createAsyncThunk(
  "submit/user/feedback",
  async (patchData, thunkApi) => {
    try {
      const result = fetchInterceptors(
        REACT_APP_END_POINT_SUBMIT_FEEDBACK_FORM,
        "PATCH",
        patchData
      );
      return result;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const submit_User_feedback_Slice = createSlice({
  name: "submitUserFeedback",
  initialState: {
    response: null,
    success: false,
    statusCode: null,
    loading: null,
  },
  reducers: {
    setDefault_Submit_User_feedback: (state) => {
      state.response = null;
      state.success = false;
      state.statusCode = null;
      state.loading = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submit_User_feedback_Api.pending, (state) => {
        state.loading = true;
      })
      .addCase(submit_User_feedback_Api.fulfilled, (state, action) => {
        state.response = action.payload;
        state.success = action.payload?.success;
        state.statusCode = action.payload?.code;
        state.loading = false;
      })
      .addCase(submit_User_feedback_Api.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setDefault_Submit_User_feedback } =
  submit_User_feedback_Slice.actions;
export default submit_User_feedback_Slice.reducer;
